/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState, useRef } from "react";
import UtilsService from "../../core/service/UtilsService";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import ErrorHandlingService from "../../core/service/ErrorHandlingService";

function PhoneNumber(props) {
  const [phoneCodes, setPhoneCodes] = useState([]);
  const [phoneCode, setPhoneCode] = useState(props.defaultContactCode);
  const defSel = [
    {
      id: props?.defaultContactId,
      phoneCode: props?.defaultContactCode,
      name: props?.phoneCodeCountry,
    },
  ];
  const [selected, setSelected] = useState(
    props.defaultContactCode ? [defSel[0]] : []
  );

  useEffect(() => {
    props.onCodeSelected(selected);
    getPhoneCodes();
  }, []);

  const getPhoneCodes = async() => {
    UtilsService.getPhoneCodes()
      .then((response) => {
        setPhoneCodes([...response.data]);
      })
      .catch((error) => {
       
      });
  };
  return (
    <>
      <div className="col-lg-5 py-0 px-2">
        <Typeahead
          clearButton
          id="phonecodes"
          onChange={(selected) => {
            props.onCodeSelected(selected);
          }}
          labelKey={(phoneCodes) =>
            `+${phoneCodes.phoneCode} (${phoneCodes.name})`
          }
          options={phoneCodes}
          defaultSelected={selected}
          placeholder={props.codelabel}
          //defaultInputValue={defaultPhone}
          inputProps={{ required: true }}
        />
      </div>
      <div className="col-lg-7 py-0 px-2">
        <input
          type="text"
          className="form-control"
          onKeyPress={(event) => {
            if (!/[0-9]/.test(event.key)) {
              event.preventDefault();
            }
          }}
          maxLength="13"
          required
          value={props.contact}
          onChange={(e) => {
            props.phoneNumber(e.target.value);
          }}
        />
      </div>
    </>
  );
}

export default PhoneNumber;
